var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconStudentLoan(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M19.6564 21.9974C19.5874 21.9974 19.5194 21.9834 19.4554 21.9554L15.2885 20.1225C15.1075 20.0425 14.9895 19.8635 14.9895 19.6645C14.9895 19.4655 15.1065 19.2865 15.2885 19.2065L19.4554 17.3735C19.5834 17.3175 19.7303 17.3175 19.8583 17.3735L24.0252 19.2065C24.2062 19.2865 24.3232 19.4655 24.3232 19.6645C24.3232 19.8635 24.2062 20.0425 24.0242 20.1225L19.8573 21.9554C19.7943 21.9834 19.7253 21.9974 19.6564 21.9974Z",
    fill: "#FFE8FB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M20.2606 22.8702C20.0666 22.9551 19.8646 22.9971 19.6566 22.9971C19.4487 22.9971 19.2467 22.9551 19.0547 22.8712L16.3228 21.6692V22.1282C16.3228 22.5352 16.5357 22.9171 16.8767 23.1251C17.8377 23.7071 18.7467 23.9991 19.6556 23.9991C20.5646 23.9991 21.4736 23.7071 22.4346 23.1251C22.7765 22.9171 22.9885 22.5352 22.9885 22.1282V21.6692L20.2606 22.8702Z",
    fill: "#FFE8FB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M14.3226 14.6668C12.4847 14.6668 10.9897 13.1718 10.9897 11.3339C10.9897 9.49595 12.4847 8 14.3226 8C16.1606 8 17.6555 9.49495 17.6555 11.3329C17.6555 13.1708 16.1606 14.6668 14.3226 14.6668Z",
    fill: "#FFE8FB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M13.6561 19.6668C13.6561 18.9398 14.0831 18.2798 14.749 17.9868L18.6019 16.2869C18.2159 16.0999 17.7829 15.9999 17.323 15.9999H11.3231C9.6702 15.9999 8.32324 17.3468 8.32324 18.9998V21.6667C8.32324 21.8527 8.47024 21.9997 8.65623 21.9997H14.989V21.4467L14.749 21.3397C14.0831 21.0467 13.6561 20.3867 13.6561 19.6668Z",
    fill: "#FFE8FB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconStudentLoan);
export default __webpack_public_path__ + "static/media/icon_student_loan.cde8c4262642d754d583e5dca4e480f3.svg";
export { ForwardRef as ReactComponent };